import { firebaseApp } from '../firebase/'
import history from '../history'
import { loadUserInfo } from './setting'
import { loadOrganization } from './organization'
import { loadPlans } from './plans'
import { loadUsers } from './users'
import { loadDocuments } from './documents'
import { loadReports } from './reports'
import { loadBoards } from './home'
import { loadNippoList } from './nippo'

export const login = user => ({
  type: 'LOGIN',
  payload: {
    uid: user.uid,
    emailName: user.displayName,
    email: user.email
  }
})

export const logout = () => (
  dispatch => {
    firebaseApp.auth().signOut()
    .then(_ =>  (
      dispatch({type: 'LOGOUT'})
    ))
    .catch(err => {
      console.log('Encountered error', err)
    })
  }
)

export const checkLogin = () => (
  dispatch => {
    firebaseApp.auth().onAuthStateChanged(user => {
      if (user) {
        dispatch(checkLoginEmail(user))
      } else {
        history.push('/login')
      }
    })
  }
)
const checkLoginEmail = user => (
  dispatch => {
    if(!user.email.endsWith('@tabi-labo.com') && !user.email.endsWith('@new-standard.co.jp')){
      dispatch(logout())
    }else{
      dispatch(initState(user))
    }
  }
)
const initState = user => (
  dispatch => {
    dispatch(login(user))
    dispatch(loadUserInfo(user))
    dispatch(loadUsers())
    dispatch(loadBoards())
    dispatch(loadReports())
    dispatch(loadOrganization())
    dispatch(loadPlans())
    dispatch(loadDocuments())
    dispatch(loadNippoList())
  }
)



// WEBPACK FOOTER //
// ./src/actions/login.js